module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">{{message.text}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/alert.component.html
// module id = 581
// module chunks = 0